const rtcServers = {
    'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, {
            'urls': 'turn:numb.viagenie.ca',
            'credential': 'webrtc',
            'username': 'websitebeaver@mail.com'
        },
        { urls: 'stun:stun.l.google.com:19302' }, { urls: 'stun:global.stun.twilio.com:3478?transport=udp' }]
};
const Peer = require('simple-peer');
export class P2PSignaling {
    //  private connected: boolean;
    constructor(profileId, initiator) {
        this.profileId = profileId;
        console.log('initializing peer connection');
        this.peer = new Peer({ initiator: initiator, config: { rtcServers } });
        // @ts-ignore
        this.database = firebase.database().ref(`/signals/rtc`);
        this.peer.on('signal', async (data) => {
            const msg = this.database.push({ sender: this.profileId, message: data });
            await msg.remove();
        });
        this.peer.on('connect', async (data) => {
            console.log(data);
            //  this.connected = true;
        });
        this.peer.on('stream', async (data) => {
            console.log(data);
        });
        this.peer.on('close', async (data) => {
            console.log(data);
            // this.connected = false;
        });
        this.database.on(`child_added`, (data) => {
            let value = data.val();
            const sender = value.sender;
            if (sender != this.profileId) {
                this.peer.signal(value.message);
            }
        });
        this.peer.on('error', (error) => {
            console.log(error);
        });
    }
    destroy() {
        this.peer.disconnect();
    }
    send(data) {
        this.peer.send(data);
    }
}
